import { Link } from 'react-router-dom';

export function QBDisconnected() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-100">
              <svg
                className="h-10 w-10 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>

          {/* Title */}
          <h2 className="text-center text-2xl font-bold text-gray-900 mb-4">
            You've Disconnected from QuickBooks
          </h2>

          {/* Message */}
          <div className="space-y-3 text-sm text-gray-600 mb-6">
            <p>We're sorry to see you go. Your QuickBooks integration has been disconnected.</p>
            <p>
              All your synced data (vendors, accounts, and invoices) has been preserved in case you
              want to reconnect in the future.
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-md p-3">
              <p className="text-blue-800">
                You can reconnect your QuickBooks account at any time from the Settings page.
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            <Link
              to="/settings"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              Go to Settings
            </Link>
            <Link
              to="/"
              className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
